<div class="title">Perks &amp; Discounts</div>

<div class="middle">
  <i class="far fa-eye mx-3" [ngClass]="{'font-ukc-blue': isActive}"></i>
  <div>{{ isActive ? 'Active' : 'Inactive' }}</div>
</div>

<p class="fake-link">View Now</p>
